import { useEffect } from "react";
import { applyTheme, useUi } from "@/lib/store/ui";

/** Applies the persisted theme and follows the OS setting while on "system". */
export function ThemeBoot() {
  const theme = useUi((s) => s.theme);
  useEffect(() => {
    applyTheme(theme);
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => applyTheme("system");
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [theme]);
  return null;
}
